import React, { useState } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
// import DevProfile from './pages/profile/DevProfile';
import RegisterPage from "./pages/register/RegisterPage";
import DeveloperProfile from "./pages/profile/developer-profile/DeveloperProfile";
import CompanyProfile from "./pages/profile/company-profile/CompanyProfile";
import JobPost from "./pages/job-post-page/JobPost";
import CreateJobPost from "./pages/create-job-post/CreateJobPost";
import AdminRegister from "./pages/admin/register/AdminRegister";
import AdminLogin from "./pages/admin/login/AdminLogin";
import AdminDashboard from "./pages/admin/dashboard/AdminDashboard";
import Protected from "./components/protected/Protected";
import Jobs from "./pages/jobs/Jobs";
import SupportPage from "./pages/supportPage/SupportPage";
import FaqPage from "./pages/supportPage/faq-page/FaqPage";
import TicketPage from "./pages/supportPage/ticket-page/TicketPage";
import UserMgmt from "./pages/admin/management/users/UserMgmt";
import TicketMgmt from "./pages/admin/management/tickets/TicketMgmt";
import JobsMgmt from "./pages/admin/management/jobs/JobsMgmt";
import UserMgmtUpdate from "./pages/admin/management/users/UserMgmtUpdate";
import TicketMgmtUpdate from "./pages/admin/management/tickets/TicketMgmtUpdate";
import UpdateProfile from "./pages/profile/updateProfile/UpdateProfile";
import NotFound from "./pages/404/NotFound";

function App() {
  const [admin, setAdmin] = useState("admin");

  const [devAd, setDevAd] = useState(["developer", "admin"]);
  const [compAd, setCompAd] = useState(["company", "admin"]);
  const [devCompAd, setDevCompAd] = useState(["developer", "company", "admin"]);

  return (
    <div className="App">
      <Routes>
        <Route index path="/" element={<Home />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<Login />} />

        <Route
          path="/profile/developer/:id"
          element={
            <Protected role={devAd} redirectTo={"/login"}>
              <DeveloperProfile />
            </Protected>
          }
        />

        <Route
          path="/profile/developer/update"
          element={
            <Protected role={devAd} redirectTo={"/login"}>
              <UpdateProfile />
            </Protected>
          }
        />

        <Route
          path="/profile/company/update"
          element={
            <Protected role={compAd} redirectTo={"/login"}>
              <UpdateProfile />
            </Protected>
          }
        />

        <Route
          path="/profile/company/:id"
          element={
            <Protected role={compAd} redirectTo={"/login"}>
              <CompanyProfile />
            </Protected>
          }
        />

        <Route path="/support">
          <Route
            path="/support"
            index
            element={
              <Protected role={devCompAd} redirectTo={"/login"}>
                <SupportPage />
              </Protected>
            }
          />
          <Route
            path="/support/faq"
            element={
              <Protected role={devCompAd} redirectTo={"/login"}>
                <FaqPage />
              </Protected>
            }
          />
          <Route
            path="/support/ticket"
            element={
              <Protected role={devCompAd} redirectTo={"/login"}>
                <TicketPage />
              </Protected>
            }
          />
        </Route>
        <Route
          path="/jobs"
          element={
            <Protected role={devAd} redirectTo={"/login"}>
              <Jobs />
            </Protected>
          }
        ></Route>
        {/* protected only logged in users, both dev and company */}
        <Route
          path="/job/:id"
          element={
            <Protected role={devCompAd} redirectTo={"/login"}>
              <JobPost />
            </Protected>
          }
        />

        <Route
          path="/company/create-job-post"
          element={
            <Protected role={compAd} redirectTo={"/login"}>
              <CreateJobPost />
            </Protected>
          }
        />
        <Route path="/admin">
          <Route
            path="register"
            element={
              <Protected role={admin} redirectTo={"/login"}>
                <AdminRegister />
              </Protected>
            }
          />
          <Route path="login" element={<AdminLogin />} />
          <Route
            path="dashboard"
            element={
              <Protected role={admin} redirectTo={"/login"}>
                <AdminDashboard />
              </Protected>
            }
          />
        </Route>

        <Route
          path="admin/users"
          element={
            <Protected role={admin} redirectTo={"/login"}>
              <UserMgmt />
            </Protected>
          }
        ></Route>
        <Route
          path="/admin/users/:role/:id"
          element={
            <Protected role={admin} redirectTo={"/login"}>
              <UserMgmtUpdate />
            </Protected>
          }
        />
        <Route
          path="/admin/users/:role/:id"
          element={
            <Protected role={admin} redirectTo={"/login"}>
              <UserMgmtUpdate />
            </Protected>
          }
        />
        <Route
          path="/admin/tickets"
          element={
            <Protected role={admin} redirectTo={"/login"}>
              <TicketMgmt />
            </Protected>
          }
        />
        <Route
          path="admin/tickets/:id"
          element={
            <Protected role={admin} redirectTo={"/login"}>
              <TicketMgmtUpdate />
            </Protected>
          }
        />
        <Route
          path="admin/jobs"
          element={
            <Protected role={admin} redirectTo={"/login"}>
              <JobsMgmt />
            </Protected>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
